// src/pages/History/MiddleAges/ByzantineEmpireGo.jsx
import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Middle_Ages_-_Byzantine_Empire.png';

function HistoryPageByzantineGo() {
  return (
    <QuizPage
      title="History: Byzantine Empire"
      subTopic="Byzantine Empire"
      backgroundImage={historyImage}
      returnPath="/History-Byzantine-Empire"
    />
  );
}

export default HistoryPageByzantineGo;   